import Pikaday from 'pikaday'
import hyperdom from 'hyperdom'
import parseDate from '../../../packages/dates/parse.js'
import LocalDate from '@booking-services/localDate'

export default function datePicker (target, options) {
  var binding = hyperdom.binding(options.binding)

  return hyperdom.viewComponent({
    onadd (el) {
      const setElementValue = () => binding.get() ? el.value = new LocalDate(dateValue(binding.get(), options.format)).format(options.parseFormat || options.format) : undefined
      setElementValue()
      const pikadayOptions = {
        field: el,
        parseFormat: options.parseFormat,
        format: options.format,
        yearRange: !!options.maxDate && !!options.minDate ? [options.minDate.getFullYear(), options.maxDate.getFullYear()] : options.yearRange,
        defaultDate: (options.defaultDate
          ? options.defaultDate.date
            ? options.defaultDate.toDate()
            : options.defaultDate
          : undefined)
          || options.minDate,
        minDate: options.minDate,
        maxDate: options.maxDate,
        onSelect: function () {
          binding.set(dateValue(this.toString(), options.parseFormat))
        },
        onOpen: function () {
          const currentValue = binding.get()
          if (currentValue) {
            setElementValue()
            pikadayOptions.setDefaultDate = true
            pikadayOptions.defaultDate = parseDate(currentValue, options.format)
          }
          const date = pikadayOptions.defaultDate || new Date()
          this.gotoDate(date)
        },
      }

      this.picker = new Pikaday(pikadayOptions)
      // line below prevents an iOS browser from closing a picker when switched a year
      el.removeEventListener('blur', this.picker._onInputBlur)
      setCalendarWidth(this.picker)
      el.addEventListener('change', () => {
        binding.set(dateValue(el.value, options.parseFormat))
        this.refresh()
      })
    },

    onremove () {
      this.picker.destroy()
    },

    render () {
      return target
    },
  })
}

function dateValue (string, format) {
  const date = parseDate(string, format)
  if (date) {
    return LocalDate.fromDate(date).format('YYYY-MM-DD')
  }
  return string
}

function setCalendarWidth (picker) {
  const inputWidth = picker._o.field.getBoundingClientRect().width
  picker.el.style.width = `${Math.max(inputWidth, 250)}px`
}
